/* ============================================================
   Sonny Label — Bundable tile gallery enhancements (THEME ASSET)
   ------------------------------------------------------------
   Upload to: Online Store > Themes > ... > Edit code > assets/
   Reference once in theme.liquid (before </body>):
       <script src="{{ 'bundable-sonny.js' | asset_url }}" defer="defer"></script>
   Pairs with bundable-sonny.css

   #3  Mobile swipe: drag/swipe across a product tile to flip
       through ALL of that product's images.
   #1  Video on hover (DESKTOP ONLY): play the product's uploaded
       video when the cursor is over the tile.

   No app/server changes. Reads /tools/bundle-builder/<hash>/new.json
   (image lists + handle) and, lazily on first hover, the product's
   /products/<handle>.js (video). Self-guards (only acts when a
   Bundable widget is present), idempotent, and re-applies across
   the widget's re-renders via a debounced MutationObserver.
   ============================================================ */
(function () {
  "use strict";

  var CONFIG = {
    swipe: true, // #3
    videoHover: true, // #1 (desktop hover only)
    cdnWidth: 400, // match the widget's tile image width
    hoverDelay: 120, // ms to wait before loading/playing hover video
    swipeThreshold: 24, // px of horizontal travel that counts as a swipe
  };

  var canHover =
    !!window.matchMedia &&
    window.matchMedia("(hover: hover) and (pointer: fine)").matches;

  function cdnResize(url) {
    if (!url || url.indexOf("cdn.shopify.com") === -1) return url;
    return (
      url + (url.indexOf("?") > -1 ? "&" : "?") + "width=" + CONFIG.cdnWidth
    );
  }

  function getHashes() {
    var nodes = document.querySelectorAll("[data-bundle-hash-id]");
    var seen = {},
      out = [];
    for (var i = 0; i < nodes.length; i++) {
      var h = nodes[i].getAttribute("data-bundle-hash-id");
      if (h && !seen[h]) {
        seen[h] = 1;
        out.push(h);
      }
    }
    return out;
  }

  var hashData = {}; // hash -> Promise<productsArray>

  function fetchBundle(hash) {
    return fetch("/tools/bundle-builder/" + hash + "/new.json", {
      headers: { Accept: "application/json" },
      credentials: "same-origin",
    })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .catch(function () {
        return null;
      });
  }

  function getProductsForHash(hash) {
    if (!hashData[hash]) {
      hashData[hash] = fetchBundle(hash).then(function (d) {
        if (!d) {
          delete hashData[hash]; // transient failure — allow a later retry
          return [];
        }
        var all = (d.products || []).slice();
        if (d.step_products && typeof d.step_products === "object") {
          Object.keys(d.step_products).forEach(function (k) {
            if (Array.isArray(d.step_products[k])) {
              all = all.concat(d.step_products[k]);
            }
          });
        }
        return all;
      });
    }
    return hashData[hash];
  }

  function buildBundleMap() {
    var hashes = getHashes();
    if (!hashes.length) return Promise.resolve({});
    return Promise.all(hashes.map(getProductsForHash)).then(function (sets) {
      var map = {};
      sets.forEach(function (products) {
        (products || []).forEach(function (p) {
          if (!p || p.id == null) return;
          var id = String(p.id);
          if (map[id]) return;
          map[id] = {
            images: (p.images || [])
              .map(function (im) {
                return im && im.src;
              })
              .filter(Boolean),
            handle: p.handle || null,
          };
        });
      });
      return map;
    });
  }

  var videoPromises = {}; // handle -> Promise<videoUrl|null>

  function fetchVideoUrl(handle) {
    if (!handle) return Promise.resolve(null);
    if (videoPromises[handle]) return videoPromises[handle];
    videoPromises[handle] = fetch("/products/" + handle + ".js", {
      credentials: "same-origin",
    })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (prod) {
        var media = (prod && prod.media) || [];
        for (var i = 0; i < media.length; i++) {
          var m = media[i];
          // Only natively-uploaded videos (not YouTube/Vimeo embeds)
          if (m.media_type === "video" && m.sources && m.sources.length) {
            var pick = null;
            for (var j = 0; j < m.sources.length; j++) {
              var f = (m.sources[j].format || m.sources[j].mime_type || "") + "";
              if (/mp4/i.test(f)) {
                pick = m.sources[j];
                break;
              }
            }
            return (pick || m.sources[0]).url || null;
          }
        }
        return null;
      })
      .catch(function () {
        return null;
      });
    return videoPromises[handle];
  }

  function setupSwipe(wrap, rawImages) {
    var images = rawImages.map(cdnResize);
    var sig = images.join("|");
    var hasDots = !!wrap.querySelector(".sl-dots");

    if (wrap.__slSig === sig && hasDots) return;

    wrap.__slSig = sig;
    wrap.__slImages = images;
    if (wrap.__slIdx == null || wrap.__slIdx >= images.length) wrap.__slIdx = 0;

    var dots = wrap.querySelector(".sl-dots");
    if (!dots) {
      dots = document.createElement("div");
      dots.className = "sl-dots";
      wrap.appendChild(dots);
    }
    dots.innerHTML = "";
    images.forEach(function (_, i) {
      var b = document.createElement("button");
      b.type = "button";
      b.setAttribute("aria-label", "View image " + (i + 1));
      b.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        show(i);
      });
      dots.appendChild(b);
    });

    function show(i) {
      var imgs = wrap.__slImages || [];
      if (!imgs.length) return;
      i = ((i % imgs.length) + imgs.length) % imgs.length;
      wrap.__slIdx = i;
      var im = wrap.querySelector("img");
      if (im) im.src = imgs[i];
      var btns = dots.querySelectorAll("button");
      for (var k = 0; k < btns.length; k++) {
        if (k === i) btns[k].setAttribute("aria-current", "true");
        else btns[k].removeAttribute("aria-current");
      }
    }
    wrap.__slShow = show;
    show(wrap.__slIdx); // apply current (restores position after a re-render)

    if (wrap.__slSwipeBound) return; // attach gesture listeners once per wrap
    wrap.__slSwipeBound = true;

    var startX = 0,
      startY = 0,
      moved = false,
      horizontal = false,
      suppress = false;

    wrap.addEventListener(
      "touchstart",
      function (e) {
        if (!e.touches || e.touches.length !== 1) return;
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        moved = false;
        horizontal = false;
      },
      { passive: true },
    );

    wrap.addEventListener(
      "touchmove",
      function (e) {
        if (!e.touches || e.touches.length !== 1) return;
        var dx = e.touches[0].clientX - startX;
        var dy = e.touches[0].clientY - startY;
        if (!moved && (Math.abs(dx) > 6 || Math.abs(dy) > 6)) {
          moved = true;
          horizontal = Math.abs(dx) > Math.abs(dy);
        }
        if (horizontal) e.preventDefault();
      },
      { passive: false },
    );

    wrap.addEventListener(
      "touchend",
      function (e) {
        if (!moved || !horizontal) return;
        var endX =
          e.changedTouches && e.changedTouches[0]
            ? e.changedTouches[0].clientX
            : null;
        if (endX == null) return;
        var dx = endX - startX;
        if (Math.abs(dx) >= CONFIG.swipeThreshold) {
          (wrap.__slShow || function () {})(wrap.__slIdx + (dx < 0 ? 1 : -1));
          suppress = true;
          setTimeout(function () {
            suppress = false;
          }, 350);
        }
      },
      { passive: true },
    );

    wrap.addEventListener(
      "click",
      function (e) {
        if (suppress) {
          e.preventDefault();
          e.stopPropagation();
          suppress = false;
        }
      },
      true,
    );
  }

  function setupVideoHover(wrap, handle) {
    if (wrap.__slVideoBound) return;
    wrap.__slVideoBound = true;

    var timer = null,
      video = null;

    function start() {
      if (timer) return;
      timer = setTimeout(function () {
        timer = null;
        fetchVideoUrl(handle).then(function (url) {
          if (!url) return;
          if (!video) {
            video = document.createElement("video");
            video.className = "sl-hover-video";
            video.muted = true;
            video.loop = true;
            video.playsInline = true;
            video.setAttribute("muted", "");
            video.setAttribute("playsinline", "");
            video.preload = "none";
          }
          if (!video.isConnected) wrap.appendChild(video);
          if (video.getAttribute("src") !== url) video.src = url;
          video.style.opacity = "1";
          var p = video.play();
          if (p && p.catch) p.catch(function () {});
        });
      }, CONFIG.hoverDelay);
    }

    function stop() {
      if (timer) {
        clearTimeout(timer);
        timer = null;
      }
      if (video) {
        try {
          video.pause();
        } catch (e) {}
        video.style.opacity = "0";
      }
    }

    wrap.addEventListener("mouseenter", start);
    wrap.addEventListener("mouseleave", stop);
  }

  function enhance(map) {
    var cards = document.querySelectorAll(
      ".bdlr__product-card[data-product-id]",
    );
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      var info = map[card.getAttribute("data-product-id")];
      if (!info) continue;
      var wrap = card.querySelector(".bdlr__card-img");
      if (!wrap) continue;
      if (CONFIG.swipe && info.images && info.images.length > 1) {
        setupSwipe(wrap, info.images);
      }
      if (CONFIG.videoHover && canHover && info.handle) {
        setupVideoHover(wrap, info.handle);
      }
    }
  }

  function scan() {
    if (!getHashes().length) return; // no Bundable widget on the page (yet)
    buildBundleMap().then(function (map) {
      if (Object.keys(map).length) enhance(map);
    });
  }

  function start() {
    scan();
    var t = null;
    var obs = new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(scan, 150);
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
